import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('CourseEnrollment');

export default {
    state: {
        ...EdverumTable.search.state,
        createdEnrollments: [],
        courseId: null,
    },

    getters: {
        ...EdverumTable.search.getters,
    },

    actions: {
        addCreatedEnrollment({ commit }, enrollment) {
            commit('ADD_CREATED_ENROLLMENT', enrollment);
        },

        reset: collectionHelpers.actions.reset('CourseEnrollments'),
    },

    mutations: {
        ...EdverumTable.search.mutations,

        ADD_CREATED_ENROLLMENT(state, enrollment) {
            state.createdEnrollments.push(enrollment);
        },

        SET_COURSE_ID(state, courseId) {
            state.courseId = courseId;
        },
    },
};
